import React from 'react'
import './FooterSec3.css'

function FooterSec3() {
  return (
    <section className='footer-sec-3'>
      <div className='container'>
        <div className='section-3-3'>
          <h6>Made With Love By Figmaland All Right Reserved </h6>
          <div className='footer-icons'>
            <img src='assets/img/fb.png' alt='fb' />
            <img src='assets/img/instagram.png' alt='instagram' />
            <img src='assets/img/twitter.png' alt='twitter' />
            <img src='assets/img/youtube.png' alt='youtube' />
          </div>
        </div>
      </div>
    </section>
  )
}

export default FooterSec3